export const environment = {
	PRODUCTION: false,
	APP_NAME: 'KreateList-Dev',
	API_V1_END_POINT: 'https://api-dev.kreatelist.com/api/v1'
};
